import { FailedPspNotificationDto } from '../../../../generated-api'

export const getReason = (notification: FailedPspNotificationDto) => {
    const payload = notification.payload

    const reason = extractValue(notification, 'reason')
    if (reason) {
        return reason
    }

    if (payload?.includes('Insufficient')) {
        return 'Insufficient funds'
    }
}

export const extractPaymentReference = (notification: FailedPspNotificationDto): string => {
    const payload = notification.payload
    if (!payload) return ''

    const match = /"merchantReference"\s*:\s*"([^"]+)"/.exec(payload)
    return match ? match[1] : ''
}

export const extractValue = (notification: FailedPspNotificationDto, value: string): string => {
    const payload = notification.payload
    if (!payload) return ''

    const match = new RegExp(`"${value}"\\s*:\\s*"([^"]+)"`).exec(payload)
    return match ? match[1] : ''
}
